import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-chevron',
    templateUrl: './chevron.component.html',
    styleUrls: ['./chevron.component.scss'],
    standalone: true,
    imports: [NgClass]
})
export class ChevronComponent implements OnInit {
    @Input() direction: string;

    ngOnInit() {
        this.directionClass();
    }

    directionClass() {
        return `icon-chevron--${this.direction}`;
    }
}
